(ns common.toaster-bus.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Snackbar$default" :as Snackbar]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.toaster-bus.db :as db]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

;; TODO: Consider https://github.com/iamhosseindhv/notistack to replace
;; Re-frame toasters.

(defui copy-button []
  (let [[status set-status] (uix/use-state nil)
        [visible set-visible] (uix/use-state false)]
    (uix/use-effect (fn []
                      (when status
                        (set-visible true)))
                    [status])
    ($ Stack
       {:direction "row"
        :mt 2
        :alignItems "center"}
       ($ Button
          {:onClick (fn [_e]
                      (rf/dispatch [::db/copy-full-message set-status]))
           :sx #js {:color "text.primary"
                    :mr 1}}
          "Copy text")
       (when status
         ($ Fade
            {:in visible
             :timeout 500
             :onEntered #(set-visible false)
             :onExited #(set-status nil)}
            ($ Icon
               {:color (name status)}
               (case status
                 :success "check"
                 :error "close")))))))

(defui toaster-root []
  (let [{:keys [id message type full-message snackbar-props]} (use-subscribe [::db/message])
        expanded (use-subscribe [::db/expanded?])
        open (use-subscribe [::db/open?])]
    ($ Snackbar
       (merge {:key id
               :open (boolean open)
               ;; Will mark open false, so the close transition will start.
               :onClose (fn [_e reason]
                          ;; Ignore close when clicking on other buttons
                          (when (not= "clickaway" reason)
                            (rf/dispatch [::db/close id])))
               ;; Clear the state when transition is done.
               :TransitionProps #js {:onExited #(rf/dispatch [::db/closed id])}
               ;; Will trigger onClose after the duration
               :autoHideDuration (when (not= :error type)
                                   3000)
               :anchorOrigin #js {:vertical "top"
                                  :horizontal "left"}
               :sx #js {;; Full-width
                        :right "24px !important"}}
              snackbar-props)
       (when id
         ($ Alert
            {:severity (some-> type name)
             :iconMapping #js {:info ($ Icon "info")
                               :success ($ Icon "check")
                               :error ($ Icon "error")}
             :sx #js {:width "100%"
                      :display "flex"
                      :color "text.primary"
                      ".MuiAlert-action" #js {:flexShrink 0
                                              :pt 0}}
             :action ($ :<>
                        (when full-message
                          ($ Button
                             {:onClick #(rf/dispatch [::db/full-message-toggle])
                              :sx #js {:color "text.primary"}}
                             (if expanded
                               "Hide full message"
                               "Show full message")))
                        ($ IconButton
                           {:onClick #(rf/dispatch [::db/close id])}
                           ($ Icon "close")))}
            ($ Typography {:sx #js {:fontSize "h5.fontSize"
                                    :fontWeight 500}}
               message)
            (when expanded
              ($ :<>
                 ($ Divider
                    {:sx #js {:my 2}})
                 ($ Typography
                    {:component "pre"
                     :sx #js {:fontFamily "Monospace"
                              :whiteSpace "pre-wrap"}}
                    full-message)
                 (when (= type :error)
                   ($ copy-button)))))))))
